<template>
  <v-text-field
    solo
    rounded
    clearable
    prepend-inner-icon="search"
    :placeholder="placeholder"
    :value="modelValue"
    @input="onInput($event)"
  />
</template>

<script>
import { Debouncer } from '@/shared/services/debouncer';

export default {
  name: 'PortfolioSearch',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    inputEventDebounceMs: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      value: '',
      debouncer: new Debouncer(this.emitInputEvent, this.inputEventDebounceMs),
    };
  },
  methods: {
    onInput(value) {
      this.value = value;
      this.debouncer.execute();
    },
    emitInputEvent() {
      this.$emit('input', this.value);
    },
  },
};
</script>
